module.exports = __webpack_public_path__ + "assets/img/0.6bf866ab.png";